/* global APPLICATION_CONFIG */

import axios from "axios";

const http = axios.create({
    withCredentials: true,
});

const refreshHttp = axios.create({
    withCredentials: true,
});

let refreshPromise = null;
let sessionExpiredHandler = null;

export function setSessionExpiredHandler(handler) {
    sessionExpiredHandler = handler;
}

http.interceptors.response.use(
    response => response,

    async error => {
        const originalRequest = error.config;

        if (
            error.response?.status !== 401 ||
            !originalRequest ||
            originalRequest._retry ||
            originalRequest.skipAuthRefresh
        ) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            if (!refreshPromise) {
                refreshPromise = refreshHttp.post(
                    `${APPLICATION_CONFIG.api.authURL}/refresh`,
                    {},
                    {
                        withCredentials: true,
                    }
                ).finally(() => {
                    refreshPromise = null;
                });
            }

            await refreshPromise;

            return http(originalRequest);
        }
        catch (refreshError) {
            if (sessionExpiredHandler) {
                sessionExpiredHandler();
            }

            return Promise.reject(refreshError);
        }
    }
);

export default http;